var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1471_6983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54308 11.9961C9.55454 11.9961 11.9958 9.55479 11.9958 6.54332C11.9958 3.53185 9.55454 1.09058 6.54308 1.09058C3.53161 1.09058 1.09033 3.53185 1.09033 6.54332C1.09033 9.55479 3.53161 11.9961 6.54308 11.9961Z",
    stroke: "#9CA3AF",
    strokeWidth: 0.95423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09033 6.5433H11.9958",
    stroke: "#9CA3AF",
    strokeWidth: 0.95423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54291 1.09058C7.9068 2.58373 8.68189 4.52146 8.72401 6.54332C8.68189 8.56518 7.9068 10.5029 6.54291 11.9961C5.17903 10.5029 4.40394 8.56518 4.36182 6.54332C4.40394 4.52146 5.17903 2.58373 6.54291 1.09058Z",
    stroke: "#9CA3AF",
    strokeWidth: 0.95423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1471_6983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0866,
    height: 13.0866,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/SVG (3).af2a9efa5ac7a4ff3fbedb0cc2ca1b4e.svg";
export { ForwardRef as ReactComponent };